import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useTheme } from '@/contexts/ThemeContext';
import { regionConfig } from '@/config/region';

interface ContactPopoverProps {
  children: React.ReactNode;
}

const ContactPopover: React.FC<ContactPopoverProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const { theme } = useTheme();

  const bgColor = theme === 'dark' ? '#1a1a1a' : 'white';
  const textColor = theme === 'dark' ? '#FFFFFF' : '#111111';
  const mutedColor = theme === 'dark' ? '#AAAAAA' : '#555555';
  const borderColor = theme === 'dark' ? '#333333' : '#E0E0E0';

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <PopoverTrigger asChild>
          {children}
        </PopoverTrigger>
        <PopoverContent 
          className="w-64 p-4 z-50 shadow-lg"
          style={{
            backgroundColor: bgColor,
            border: `1px solid ${borderColor}`,
          }}
          side="top"
          align="start"
          sideOffset={8}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          <div className="space-y-3">
            <h4 className="font-semibold text-sm uppercase" style={{ color: textColor }}>
              Contact Us
            </h4>
            <div className="space-y-2">
              <a 
                href={`mailto:${regionConfig.email}`}
                className="flex items-center gap-2 text-sm transition-colors"
                style={{ color: mutedColor }}
                onMouseEnter={(e) => e.currentTarget.style.color = textColor}
                onMouseLeave={(e) => e.currentTarget.style.color = mutedColor}
              >
                <Mail className="w-4 h-4" />
                <span>{regionConfig.email}</span>
              </a>
            </div>
          </div>
        </PopoverContent>
      </div>
    </Popover>
  );
};

export default ContactPopover;
